<template>
  <div class="center">

    <div
      v-if="connectionFailed"
      class="connection-error">

      <h1>
        V delu...
      </h1>
      <p class="mb-4">
        {{ getErrorMessage(errCode) }}
      </p>

      <input-button
        inputPlaceholder="Back to Qwilink"
        @click="returnToQwilink" />
    </div>

    <div v-else>
      <h1>
        Working on it...
      </h1>
    </div>
  </div>
</template>

<script>
import routingHelper from '@/assets/modules/routing/routingHelper'
import localStorageStructure from '@/assets/configurations/localStorageStructure.json'
import localStorageHelper from '@/assets/modules/localStorageHelper'
import jwtDecode from 'jwt-decode'
import jwtChecker from '@/assets/modules/signOn/jwtChecker'
import InputButton from '@/components/standard/input/InputButton'

export default {
  data () {
    return {
      connectionFailed: false,
      errCode: null
    }
  },

  methods: {
    returnToQwilink () {
      let {redirectTo, params} = this.buildRedirectData()
      routingHelper.redirectToInternal(this, redirectTo, params)
    },
    getErrorMessage (err) {
      switch (err) {
        case 'service.auth.ProfileMissingEmail':
          return 'Your email is missing!'
        case 'service.auth.ProfileMissingIdentity':
          return 'Your identity is missing!'
        case 'service.auth.ProfileMissingProvider':
          return 'This profile does not have a provider!'
        case 'service.auth.ProfileUnsupportedProvider':
          return 'This provider is not supported!'
        case 'service.auth.ProfileMultipleOwners':
          return 'This profile has multiple owners'

        default:
          return 'Something went really wrong!'
      }
    },
    buildRedirectData () {
      // Check if it was after an auth request
      let redirectTo = 'businessDashboard'
      let params = null
      let wasAuthRequest = localStorageHelper.getData('authConnection', 'attemptedConnection')
      if (wasAuthRequest) {
        localStorageHelper.setData('authConnection', 'attemptedConnection', false)
        let routeObject = localStorageHelper.getData('authConnection', 'destination')
        localStorageHelper.setData('authConnection', 'destination', null)
        redirectTo = routeObject.name
        params = routeObject.params
      
        // Make a status code
        if (this.$route.query.error) {
          params.status = 'failed'
          params.code = this.$route.query.error
        }

      }
      return {redirectTo, params}

    }
  },

  created () {
    if (this.$route.query.error) {
      this.connectionFailed = true
      this.errCode = this.$route.query.error
      return
    }

    try {
      if (this.$route.query && !this.$route.query.jwt) {
        // If a SSO jwt token wasn't passed...

        let {redirectTo, params} = this.buildRedirectData()
        routingHelper.redirectToInternal(this, redirectToInternal, params)
      } else {
  
        let {redirectTo, params} = this.buildRedirectData()
  
        let userObject = {
          token: this.$route.query.jwt
        }
        let decodedToken = null
  
        if (jwtChecker.checkJwt(userObject.token)) {
          decodedToken = jwtDecode(userObject.token)
        } else {
          routingHelper.redirectToInternal(this, 'login')
          return
        }

        let { email, id } = decodedToken
  
        localStorageHelper.setData('user', 'email', email)
        localStorageHelper.setData('user', 'id', id)
        localStorageHelper.setData('user', 'name', email)
        localStorageHelper.setData('user', 'token', userObject.token)
  
        // Redirect to Login for it to decide if it is valid...
  
        routingHelper.redirectToInternal(this, redirectTo, params)
      }

    } catch (e) {
      console.error(e)
    }
  },

  components: {
    'input-button': InputButton
  }
}
</script>

<style scoped>
.connection-error {
  text-align: center;
}

.center {
  display: flex;
  position: fixed;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  align-items: center;
  justify-content: center;
}

</style>




// WEBPACK FOOTER //
// src/components/route/screenLogin/SsoResponseHandler.vue?5a2bbecd